import * as Types from './types';
import { actionTypes } from './constants';

export const setIsLoginInProcess = (inProcess: boolean): Types.ISetIsLoginInProcessAction => ({
    type: actionTypes.SET_LOGIN_IN_PROCESS,
    payload: inProcess
});

export const setSsoAttempted = (): Types.ISetSsoAttemptedAction => ({
    type: actionTypes.SET_SSO_ATTEMPTED
});

export const setAutoLoginCompleted = (): Types.ISetAutoLoginCompletedAction => ({
    type: actionTypes.SET_AUTO_LOGIN_COMPLETED
});

export const setIsLogoutInProcess = (inProcess: boolean): Types.ISetIsLogoutInProcessAction => ({
    type: actionTypes.SET_LOGOUT_IN_PROCESS,
    payload: inProcess
});

export const setIsLogoutManual = (isManual: boolean): Types.ISetIsLogoutManualAction => ({
    type: actionTypes.SET_IS_LOGOUT_MANUAL,
    payload: isManual
});

export const addAfterCredentialsLoginHook = (hook: () => void): Types.IAddAfterCredentialsLoginHookAction => ({
    type: actionTypes.ADD_AFTER_CREDENTIALS_LOGIN_HOOK,
    payload: hook
});

export const addBeforeRegistrationHook = (hook: Types.TBeforeRegistrationHook):
    Types.IAddBeforeRegistrationHookAction => ({
    type: actionTypes.ADD_BEFORE_REGISTRATION_HOOK,
    payload: hook
});
